import { ToolsContainerProps } from '../../../../../../components/Container'

export const toolsUpdate: ToolsContainerProps[] = []
